/* eslint-disable @typescript-eslint/no-use-before-define */
import { Select, SelectOption } from 'components';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { ListingLabelContext } from 'contexts';
import { StyledAlert } from '../components';
import FormContext from '../FormContext';
import { UserState } from '../types';

type MemberNumberMultiMatchProps = {
  memberNumber: UserState['memberNumbers'][number];
  numberIndex: number;
};

const MemberNumberMultiMatch: React.FC<MemberNumberMultiMatchProps> = ({
  memberNumber,
  numberIndex,
}) => {
  const {
    memberNumberStates,
    memberNumberMultiMatches,
    userState,
    setUserState,
  } = useContext(FormContext);
  const { getMemberNumberString } = useContext(ListingLabelContext);

  if (!memberNumber.board || !memberNumber.number) return null;
  const key = getMemberNumberString(memberNumber.board, memberNumber.number);
  const memberNumberState = memberNumberStates[key];
  const memberNumberMultiMatch = memberNumberMultiMatches[key];

  if (!memberNumberState || !memberNumberMultiMatch) return null;

  return (
    <StyledContainer>
      {memberNumberState.multiMatch && (
        <StyledAlert
          message={
            <span>
              This member number is associated with multiple profiles in your
              brokerage&apos;s data feed. Please select this user&apos;s unique
              identifier.
            </span>
          }
          type="info"
          showIcon
        />
      )}
      <Select
        data-cy="user-select-mlsUniqueId"
        placeholder="Select"
        showSearch
        value={userState.memberNumbers[numberIndex].mlsUniqueId}
        onChange={mlsUniqueId => {
          setUserState(cur => {
            const number = cur.memberNumbers[numberIndex];
            number.mlsUniqueId = mlsUniqueId;

            return {
              ...cur,
              memberNumbers: [...cur.memberNumbers],
            };
          });
        }}
        onBlur={() =>
          setUserState(cur => {
            const next = { ...cur };
            next.memberNumbers[numberIndex].mlsUniqueIdDirty = true;
            return next;
          })
        }
      >
        {memberNumberMultiMatch.mlsUniqueIds.map(mlsUniqueId => (
            <SelectOption value={mlsUniqueId} key={mlsUniqueId}>
              {mlsUniqueId}
            </SelectOption>
          ))}
      </Select>
    </StyledContainer>
  );
};

export default MemberNumberMultiMatch;

const StyledContainer = styled.div`
  margin-top: 8px;
`;
